module.exports = __webpack_public_path__ + "img/destruction.9f64eaa9.jpg";